import { NAME } from '../../fields'

export const getInitialValues = agencyData => {
  return {
    [NAME]: agencyData[NAME] || ''
  }
}
